<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="row" *ngIf="hasError" role="alert" aria-live="polite" aria-atomic="true">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of ErrorMessages">
                    <button [innerHtml]="error"></button>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="row" *ngIf="IsErrorMesssage">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of errorMessage"><button>{{error}}</button></li>
            </ul>
        </div>
    </div>
</div>
<div class="row" aria-live="polite" aria-atomic="true">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField 
                [label]="'Agent ID for this enrollment:'" [id]="'agent-id-phone'" [text]="agentUserName"
                (onValueChange)="dataEntryStep1.AgentName = $event" [validators]="[notBlankValidator]" [disabled]="isValidAgent">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <div *ngIf="!isValidAgent">
            <button class="button primary" (click)="onContinue()" >Continue</button>
        </div>
        <div *ngIf="isValidAgent">
            <button class="button primary" (click)="onChangeAgentID()">Change Agent ID</button>
        </div>
    </div>
</div>
<div *ngIf="isValidAgent">


    <div class="row">
        <div class="col-8">
            <div class="bottom-20">
                <JQDatePicker [selectedDate]="dataEntryStep1.DateofReceipt"
                    (elementClicked)="dataEntryStep1.DateofReceipt = $event" [label]="'Date Of Receipt:'" [id]="'DateOfReceipt'" tabindex="0">
                </JQDatePicker>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="bottom-20">
                <ValidatedDropDown class="wide" for="planstate" [selectedValue]="planstate" [label]="'Select the applicant\'\s state'"
                    [disabled]="disabled" (onValueChange)="planstate = $event" [options]="states">
                </ValidatedDropDown>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Continue</button>
        </div>
    </div>


            </div>

<style>

    button.primary:not([disabled]):not(.disabled):focus {
        background-color: #166CA2;
        border: 2px solid #166CA2;
        border-bottom: 2px solid #1B75BC;
        outline-offset: 0.2rem !important;
        outline: 0.15rem solid #000 !important;
    }

    .button.primary:not([disabled]):not(.disabled):focus-visible {
        outline: -webkit-focus-ring-color solid 1px;
        outline-style: solid;
        outline-width: 4px;
        outline-offset: 4px;
        outline-color: #262626;
    }

    button:focus {
        outline-style: solid;
        outline-width: 4px;
        outline-offset: 4px;
        outline-color: #262626;
    }

    .on-dark button:focus {
        outline-color: #ffffff;
    }
</style>
